import React from 'react';

const SpinnerProcessing = (props) => {
    return (
        <div>
             <div className="loading-process">
            <h2>Processing Payment...</h2>
        </div>
        <div className="loading-spinner-processing">
            
        </div>
        </div>
    )
}

export default SpinnerProcessing;